<template>
  <div class="productsImage">
    <swiper :options="swiperOption" ref="productsImageSwiper">
      <swiper-slide
        v-for="(el, idx) in imageList"
        :key="idx"
      >
        <div class="productImg"><img :src="el" height="100%" alt=""></div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'ProductsImage',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    imageList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiperOption: {
        autoHeight: true,
        slidesPerView: 'auto',
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
        }
      }
    }
  },
  methods: {
  },
  computed: {
  },
  mounted: function() {
  },
  created: function() {
  },
  destroyed: function() {
  },
}
</script>

<style lang="scss">
.productsImage {
  
  .swiper-wrapper {
    min-height: 300px;
    max-height: 512px;
    align-items: center;
  }
  .swiper-slide {
    min-height: 200px;
    max-height: 512px;
  }
  .productImg {
    display: block;
    overflow: hidden;
  }
  img {
    display: block;
    max-width: 100%;
    max-height: 512px;
    margin: 0 auto;
  }
  .swiper-pagination-bullets {
    bottom: 3px;
  }
  .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 0 0 4px;
  }
  .swiper-pagination-bullet {
    width: 7px;
    height: 7px;
    background-color: transparent;
    border: 1px solid #fcfcfc;
    opacity: 1;
    margin-top: -1px;
  }
  .swiper-pagination-bullet-active {
    width: 8px;
    height: 8px;
    border: 1px solid #5a5fe3;
    background-color: #5a5fe3;
  }
}
@media all and (max-width: 640px) {
  .productsImage .swiper-wrapper {
    max-height: 80vw;
    img {
      max-height: 80vw;
      max-width: 100vw;
    }
  }
  .productsImage .swiper-slide {
    max-height: 80vw;

    img {
      max-height: 80vw;
    }
  }
}
</style>

